import styled from 'styled-components';

export const StyledHero = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);

  .hero__title {
    text-align: center;
    font-size: var(--fs-2xl);
    font-weight: var(--fw-bold);
    line-height: var(--lh-tight);
  }

  .hero__card-container {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--space-4);
  }

  .hero__card {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    padding: var(--space-5);
    background-color: var(--c-surface);
    border: var(--border);
    border-radius: var(--radius-lg);
  }

  .hero__card h3 {
    font-size: var(--fs-lg);
    font-weight: var(--fw-bold);
  }

  .hero__card p {
    color: var(--c-text-muted);
    font-size: var(--fs-sm);
  }

  @media (min-width: 786px) {
    .hero__title {
      font-size: var(--fs-3xl);
    }

    .hero__card-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1200px) {
    .hero__card-container {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;
